import { Guid } from '@/models/identify';
//import { BlockItem } from "@/models/Blocks/Itens/block-item";
import { BlockStruct } from '@/models/Blocks/block-struct';
import { TemplateStruct} from "@/models/Blocks/Itens/Types/template-struct";


export class CalcStructMobile{
    protected _data: {[key: string]: object} = {};
    //protected _elements: Array<BlockItem> = [];
    protected _blockKey?: string;
    protected _blockName?: string;
    protected _struct: any[][][];

    protected _templates: {[key: string]: any[][][]} = {
        "1": [[['s']]],
        "2": [[['v'],['v']]],
        "3": [[['v'],['s','s']]],
        "4": [[['s']],[['v'],['s','s']]],
        "5": [[['s']],[['v'],['s','s']],[['v']]],
        "6": [[['s']],[['v'],['s','s']],[['v'],['v']]],
        "7": [[['s']],[['v'],['s','s']],[['v']],[['v'],['v']]],
        "8": [[['s']],[['v'],['s','s']],[['v']],[['s','s'],['v']]]
    };

    public constructor(values: Array<object>, blockKey?: string, blockName?: string) {
        this._struct = [];
        this._data   = {};
        let cloneValue = [...values];
        while(cloneValue.length > 0) {
            this._formatData(cloneValue);
        }
        //console.log('CalcStructMobile blockKey ', blockKey)
        this._blockKey = blockKey;
        this._blockName = blockName;
    }

    public getStruct(): TemplateStruct {
        let b: BlockStruct = new BlockStruct(this._struct,this._data);
        if(this._blockKey){
            b.key = this._blockKey;
        }
        if(this._blockName){
            b.blockName = this._blockName;
        }
        return b.getStruct();
    }

    protected _getTemplate(numEle: number): any[][][]{
        //Max template elements
        let count = 8;

        //if is possible put all elements in the template
        if(count <= numEle){
            return this._templates['8'];
        }

        //in last case
        return this._templates[`${numEle}`];
    }

    protected _formatData(values: Array<object>){
        let template: any[][][] = this._getTemplate(values.length);
        template.forEach((row: any[]) => {
            let r:any[][] = [];
            row.forEach((col: any[]) => {
                let c:any[] = [];
                col.forEach((value: string) => {
                    let item = values.length ? values.shift() : null;
                    if(item){
                        let id = Guid.generation();
                        this._data[id] = this._formatElement(item, value);
                        c.push({type:value,id:id});
                    }
                });
                c.length && r.push(c);
            });
            r.length && this._struct.push(r);
        });
    }

    protected _formatElement(item: object, shape: string): object{
        let clone: any = {...item};
        let media = clone.social?.media ?? null;
        if(media && (media[shape] ?? null)){
            clone.social.images = media[shape].images ?? null;
            clone.social.video = media[shape].video ?? null;
        }
        return clone;
    }
}
